export default "__VITE_ASSET__21cb7bb5__"